/**
 * Indicatore inline "prezzi disallineati" per una singola riga preventivo.
 * Dot blu lampeggiante + tooltip — compatto, non rompe il layout della table.
 */
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useEstimateRowStaleStatus } from '@/hooks/useEstimateRowStaleStatus';

interface RowStaleDotProps {
  estimateStratigraphyId: string;
  /** Salta query se row orfana (originale eliminata) — non c'è prezzo da riallineare. */
  skip?: boolean;
}

const RowStaleDot: React.FC<RowStaleDotProps> = ({ estimateStratigraphyId, skip }) => {
  const status = useEstimateRowStaleStatus(skip ? null : estimateStratigraphyId);
  if (!status?.isStale) return null;

  // Due cause diverse, due messaggi diversi: "la parete è cambiata" è un'altra
  // cosa da "sono cambiati i prezzi dei materiali", e chi legge deve capire
  // quale delle due sta guardando.
  const motivi: string[] = [];
  if (status.stratigraphyChanged) motivi.push('la parete è stata modificata');
  if (status.staleMaterialsCount > 0) {
    motivi.push(
      `${status.staleMaterialsCount} ${status.staleMaterialsCount === 1 ? 'materiale aggiornato' : 'materiali aggiornati'}`,
    );
  }

  return (
    <span
      className="inline-flex items-center gap-1 text-blue-700 text-[10px] font-medium"
      title={`${motivi.join(' · ')} dopo l'ultimo ricalcolo. Usa "Aggiorna Prezzi" per riallineare.`}
    >
      <AlertCircle className="h-3 w-3 animate-pulse" />
      {status.stratigraphyChanged ? 'Parete modificata' : 'Prezzi disallineati'}
    </span>
  );
};

export default RowStaleDot;
